import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Content for the hidden "enter QA key" modal (see login.component.ts's
 * logo-tap trigger). Purely presentational -- the host reads getToken() via
 * ModalReference.getComponent() and does the actual validate+save call
 * (matches the RemoveFieldConfirmationComponent pattern).
 */
@Component({
  selector: 'app-qa-backdoor-modal',
  standalone: true,
  imports: [ReactiveFormsModule, FormlyModule],
  templateUrl: './qa-backdoor-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './qa-backdoor-modal.component.css',
})
export class QaBackdoorModalComponent {
  form = new FormGroup({});
  model: { token: string } = { token: '' };
  fields: FormlyFieldConfig[] = [
    {
      key: 'token',
      type: 'text',
      props: {
        label: 'QA Key',
        placeholder: 'Enter QA key',
        type: 'password',
        required: true,
      },
    },
  ];

  getToken(): string {
    return this.model.token.trim();
  }
}
